import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function AttendanceReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Reference No",
      accessorKey: "Reference No",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },

    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "In Time",
      accessorKey: "In Time",
    },
    {
      header: "Out Time",
      accessorKey: "Out Time",
    },
    {
      header: "Time Count",
      accessorKey: "Time Count",
    },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "Employee",
    },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Attendance Report"}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default AttendanceReport;
